import React from "react";
import { getValue } from "@utils/lodash";

function ChangeOwnerSubheaderSvgComponent(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" 
      height={
        getValue(props, `size`, "") ? getValue(props, `size`, "") : "24px"
      }
      width={
        getValue(props, `size`, "") ? getValue(props, `size`, "") : "24px"
      }
    viewBox="0 0 24 24">
    <defs>
      <clipPath id="clip-path-change-owner">
        <rect id="Rectangle_18195" data-name="Rectangle 18195" width="24" height="24" transform="translate(-14688 -8264)" fill="#fff"/>
      </clipPath>
    </defs>
    <g id="Mask_Group_303" data-name="Mask Group 303" transform="translate(14688 8264)" clip-path="url(#clip-path-change-owner)">
      <path id="psychology_alt_FILL0_wght300_GRAD0_opsz24_1_" data-name="psychology_alt_FILL0_wght300_GRAD0_opsz24 (1)" d="M7.1-9.158v-3.819A8.908,8.908,0,0,1,5.125-15.8a8.1,8.1,0,0,1-.7-3.312,8,8,0,0,1,2.217-5.7,7.129,7.129,0,0,1,5.383-2.347,7.24,7.24,0,0,1,4.659,1.65,7.523,7.523,0,0,1,2.668,4.28l1.045,4.372a.844.844,0,0,1-.142.736.762.762,0,0,1-.646.331H17.832v3.024a1.7,1.7,0,0,1-.475,1.209,1.514,1.514,0,0,1-1.141.5h-1.96v1.895H12.915v-3.316h3.3a.26.26,0,0,0,.2-.082.293.293,0,0,0,.077-.21v-4.445h2.414l-.849-3.671a6.189,6.189,0,0,0-2.2-3.51,5.981,5.981,0,0,0-3.836-1.345A5.894,5.894,0,0,0,7.6-23.816a6.518,6.518,0,0,0-1.833,4.672,6.767,6.767,0,0,0,.548,2.7,7.094,7.094,0,0,0,1.553,2.27l.581.567v4.453ZM12.334-17.447Zm-.4,2.988a.728.728,0,0,0,.551-.236.817.817,0,0,0,.223-.584.819.819,0,0,0-.222-.584.727.727,0,0,0-.551-.236.728.728,0,0,0-.551.236.817.817,0,0,0-.223.584.819.819,0,0,0,.222.584.727.727,0,0,0,.551.236Zm-.524-2.813h1.08a2.276,2.276,0,0,1,.158-.886,3.522,3.522,0,0,1,.605-.888q.394-.465.757-.941a1.914,1.914,0,0,0,.363-1.194,2.124,2.124,0,0,0-.675-1.591,2.347,2.347,0,0,0-1.7-.65,2.493,2.493,0,0,0-1.487.481,2.711,2.711,0,0,0-.97,1.266l.971.445a1.772,1.772,0,0,1,.6-.809A1.447,1.447,0,0,1,12-22.346a1.324,1.324,0,0,1,.91.325,1.069,1.069,0,0,1,.367.839,1.453,1.453,0,0,1-.292.9q-.292.386-.664.789a3.967,3.967,0,0,0-.68.986,2.9,2.9,0,0,0-.233,1.233Z" transform="translate(-14688.421 -8233.842)" fill={
          getValue(props, `color`, "")
            ? getValue(props, `color`, "")
            : "#5f6368"
        } />
    </g>
    </svg>


  );
}

export default ChangeOwnerSubheaderSvgComponent;
